export default function About() {
  return (
    <>
      <section className="hero text-white">
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-start">
          <div>
            <div className="badge-soft mb-2">About PulseFrame</div>
            <h1 className="display-6 fw-bold">
              We imagined a control center teams actually want to open.
            </h1>
            <p className="lead">
              PulseFrame is fictional, but the bar it sets is real: modern, legible, mono‑minimal landing
              pages built on a dependable stack.
            </p>
          </div>
          <div className="pill">
            <i className="bi bi-people"></i> Distributed-first
          </div>
        </div>
      </section>

      <section className="mt-5">
        <h2 className="section-title mb-3">Story</h2>
        <div className="row g-3">
          <div className="col-lg-6">
            <div className="glass-card h-100">
              <h5>Why we built it</h5>
              <p className="text-muted">
                We wanted a landing site that showcases 2025 UI trends—glassmorphism, bento grids, bold
                gradients—without relying on Tailwind. The result is a multi-route SPA with a consistent
                mono‑minimal design.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="glass-card h-100">
              <h5>Principles</h5>
              <ul className="text-muted mb-0">
                <li className="mb-2">Accessibility: contrast meets AA.</li>
                <li className="mb-2">Performance: static, no heavy runtime.</li>
                <li className="mb-2">Clarity: concise copy, legible typography.</li>
                <li className="mb-2">Consistency: mono palette across routes.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <h2 className="section-title mb-3">Timeline</h2>
        <div className="row g-3">
          <div className="col-md-3">
            <div className="glass-card h-100">
              <div className="pill mb-2">2023 → 2024</div>
              <h6>Design trends evolve</h6>
              <p className="text-muted mb-0">
                Glassmorphism and bento layouts mature; Bootstrap 5.3 adds color modes.
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="glass-card h-100">
              <div className="pill mb-2">2025</div>
              <h6>This demo ships</h6>
              <p className="text-muted mb-0">Mono-minimal landing SPA ready for Workers.</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="glass-card h-100">
              <div className="pill mb-2">Today</div>
              <h6>Workers native</h6>
              <p className="text-muted mb-0">
                Cloudflare serves the static bundle with SPA routing.
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="glass-card h-100">
              <div className="pill mb-2">Future</div>
              <h6>Add your brand</h6>
              <p className="text-muted mb-0">
                Swap copy, logos, or extend layout in one CSS file.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
